/**
 * Shared atoms + helpers for the marketing landing sub-components.
 * Keep this file tiny — nothing here should know about specific sections.
 */
import { track } from "@/lib/sentry";

export function Wordmark({ size = "base" }) {
  const cls = size === "lg" ? "text-2xl" : "text-[19px]";
  return (
    <span className={`afyanex-wordmark font-heading font-bold tracking-tight ${cls}`}>
      Afya<span className="nex">nex</span>
    </span>
  );
}

export function Eyebrow({ children }) {
  return (
    <div className="text-[11px] font-semibold uppercase tracking-[0.22em] text-afyanex-pink">
      {children}
    </div>
  );
}

export function SectionHeading({ eyebrow, children, sub }) {
  return (
    <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-clinical-text leading-[1.1]">
        {children}
      </h2>
      {sub && (
        <p className="mt-5 text-base sm:text-lg text-clinical-subtext leading-relaxed max-w-2xl mx-auto">
          {sub}
        </p>
      )}
    </div>
  );
}

/** Fire-and-forget funnel event for a CTA click. */
export const cta = (location, destination) => () =>
  track("landing_cta_clicked", { location, destination });

export { track };
